export default "__VITE_ASSET__DhZfmP9V__"